import React from "react";
import CONFIG from "../src/config";
import { Link, Outlet, useNavigate } from "react-router-dom";
import "./Login.css";
import adminuser from "./images/admin_user.png";
import adminlogo from "./images/ktig_logo_black.png";
import { useState } from "react";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Dashboard = () => {
  const [activeMenu, setActiveMenu] = useState(false);
  const navigate = useNavigate();

  const [sticky, setSticky] = useState("");

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogout = async () => {
    setIsLoggedIn(false);
    document.body.classList.remove("logged-in");
    window.scrollTo({ top: 0, behavior: "smooth" });

    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${CONFIG.BASE_URL}/auth/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      Swal.fire({
        title: "Log Out?",
        text: "Are you sure want to log out?",
        icon: "warning",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Log out",
        showCancelButton: true,
        reverseButtons: true,
      }).then((response) => {
        if (response.isConfirmed) {
          localStorage.removeItem("token");
          Swal.fire({
            title: "Admin Log Out",
            text: "You have log out successfully",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
          localStorage.removeItem("authToken");
          navigate("/admin-login");
        }
      });
    } catch (error) {
      toast.error("An error occurred while logging out.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="dashboard-container ktig_dhashbaord_main">
      <div className="ktig_dhashbaord_main_inn d-flex h-100">
        {/* Sidebar */}
        <ToastContainer />

        <header class="top-header admin_dashboard_menu">
          <nav class="navbar navbar-expand align-items-center gap-4">
            <ul class="navbar-nav m-0 p-3 nav-right-links align-items-center">
              <li class="nav-item dropdown">
                <a
                  href="javascrpt:;"
                  class="dropdown-toggle dropdown-toggle-nocaret"
                  data-bs-toggle="dropdown"
                >
                  <img
                    src={adminuser}
                    class="rounded-circle p-0 border"
                    width="45"
                    height="45"
                    alt=""
                  />
                </a>
                <div class="dropdown-menu dropdown-user dropdown-menu-end shadow">
                  <ul className="m-0 p-2">
                    <li>
                      <Link to="/admin-profile" className=" p-1">
                        Profile
                      </Link>
                    </li>
                    <li>
                      <a className="p-1" onClick={handleLogout}>
                        Logout
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </nav>
        </header>

        <div className="sidebar text-white d-inline-block">
          <div className="logo-container text-center p-3">
            <img src={adminlogo} alt="KTIG" className="logo" />
          </div>
          <nav className="nav flex-column">
            <Link
              to="/admin-dashboard"
              // className={
              //   activeMenu === "/admin-dashboard"
              //     ? "nav-link cursor-pointer"
              //     : "nav-link cursor-pointer"
              // }
              className={`nav-link cursor-pointer ${
                activeMenu === "/admin-dashboard" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/admin-dashboard");
              }}
              active={activeMenu}
            >
              <i className="bi bi-house-door"></i> Dashboard
            </Link>

            <Link
              to="/blog-news"
              // className={
              //   activeMenu === "/blog-news"
              //     ? "nav-link cursor-pointer"
              //     : "nav-link cursor-pointer"
              // }
              className={`nav-link cursor-pointer ${
                activeMenu === "/blog-news" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/blog-news");
              }}
              active={activeMenu}
            >
              <i className="bi-hurricane"></i> Blogs
            </Link>
            <Link
              to="/event"
              // className={
              //   activeMenu === "/event"
              //     ? "nav-link cursor-pointer"
              //     : "nav-link cursor-pointer"
              // }
              className={`nav-link cursor-pointer ${
                activeMenu === "/event" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/event");
              }}
              active={activeMenu}
            >
              <i className="bi-journal-bookmark-fill"></i> Events
            </Link>
            <Link
              to="/contact"
              // className={
              //   activeMenu === "/contact"
              //     ? "nav-link cursor-pointer"
              //     : "nav-link cursor-pointer"
              // }
              className={`nav-link cursor-pointer ${
                activeMenu === "/contact" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/contact");
              }}
              active={activeMenu}
            >
              <i className="bi-person-fill"></i> Contact
            </Link>

            <Link
              to="/create-careers"
              className={`nav-link cursor-pointer ${
                activeMenu === "/create-careers" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/create-careers");
              }}
              active={activeMenu}
            >
              <i className="bi-receipt"></i>Careers
            </Link>
            <Link
              to="/job-application-table"
              className={`nav-link cursor-pointer ${
                activeMenu === "/job-application-table" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/job-application-table");
              }}
              active={activeMenu}
            >
              <i className="bi-layout-text-sidebar"></i> Job Application
            </Link>

            <Link
              to="/bio-data-table"
              className={`nav-link cursor-pointer ${
                activeMenu === "/bio-data-table" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/bio-data-table");
              }}
              active={activeMenu}
            >
              <i className="bi-plus-square"></i>Director Board
            </Link>
            <Link
              to="/enquiry-form"
              className={`nav-link cursor-pointer ${
                activeMenu === "/enquiry-form" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/enquiry-form");
              }}
              active={activeMenu}
            >
              <i className="bi bi-pencil-square"></i> Enquiry Forms
            </Link>
            <Link
              to="/ktnl-customer-support"
              className={`nav-link cursor-pointer ${
                activeMenu === "/ktnl-customer-support" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/ktnl-customer-support");
              }}
              active={activeMenu}
            >
              <i className="bi-receipt"></i> KTNL Customer Support
            </Link>

            <Link
              to="/account-deletion"
              className={`nav-link cursor-pointer ${
                activeMenu === "/account-deletion" ? "active-menu" : ""
              }`}
              onClick={() => {
                setActiveMenu("/account-deletion");
              }}
              active={activeMenu}
            >
              <i className="bi-receipt"></i> Account Deletion
            </Link>
          </nav>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 d-inline-block">
          {/* Content section where nested routes will be loaded */}
          <div className="content p-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
